import { cn } from "@/lib/utils";
import SearchForm from "../forms/SearchForm";
import PopoverWrapper from "../PopoverWrapper";
import { MagnifyingGlassIcon } from "@radix-ui/react-icons";

export default function MobileSearchButton() {
  return (
    <PopoverWrapper
      trigger={<MagnifyingGlassIcon className="h-5 w-5" />}
      customClasses={cn("")}
      content={
        <div className={cn()}>
          <h2 className="text-md">Search</h2>
          <SearchForm autoFocus />
        </div>
      }
    />
  );
}
